(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7385],{

/***/ 37645:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _loadable = _interop_require_default(__webpack_require__(14588));
function dynamic(dynamicOptions, options) {
    let loadableFn = _loadable.default;
    let loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: (param)=>{
            let { error , isLoading , pastDelay  } = param;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (dynamicOptions instanceof Promise) {
        loadableOptions.loader = ()=>dynamicOptions;
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
const isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    const Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return ()=>/*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 33644:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
const LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 14588:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);
var _react = _interop_require_wildcard(__webpack_require__(67294));
var _loadableContext = __webpack_require__(33644);
const ALL_INITIALIZERS = [];
const READY_INITIALIZERS = [];
let initialized = false;
function load(loader) {
    let promise = loader();
    let state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then((loaded)=>{
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch((err)=>{
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    let opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ let subscription = null;
    function init() {
        if (!subscription) {
            const sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    }
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        const moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push((ids)=>{
                for (const moduleId of moduleIds){
                    if (ids.indexOf(moduleId) !== -1) {
                        return init();
                    }
                }
            });
        }
    }
    function useLoadableModule() {
        init();
        const context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach((moduleName)=>{
                context(moduleName);
            });
        }
    }
    function LoadableImpl(props, ref) {
        useLoadableModule();
        const state = (0, _react).useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, ()=>({
                retry: subscription.retry
            }), []);
        return _react.default.useMemo(()=>{
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    }
    function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref
        }));
    }
    const LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = ()=>init();
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
class LoadableSubscription {
    promise() {
        return this._res.promise;
    }
    retry() {
        this._clearTimeouts();
        this._res = this._loadFn(this._opts.loader);
        this._state = {
            pastDelay: false,
            timedOut: false
        };
        const { _res: res , _opts: opts  } = this;
        if (res.loading) {
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) {
                    this._state.pastDelay = true;
                } else {
                    this._delay = setTimeout(()=>{
                        this._update({
                            pastDelay: true
                        });
                    }, opts.delay);
                }
            }
            if (typeof opts.timeout === "number") {
                this._timeout = setTimeout(()=>{
                    this._update({
                        timedOut: true
                    });
                }, opts.timeout);
            }
        }
        this._res.promise.then(()=>{
            this._update({});
            this._clearTimeouts();
        }).catch((_err)=>{
            this._update({});
            this._clearTimeouts();
        });
        this._update({});
    }
    _update(partial) {
        this._state = _extends({}, this._state, {
            error: this._res.error,
            loaded: this._res.loaded,
            loading: this._res.loading
        }, partial);
        this._callbacks.forEach((callback)=>callback());
    }
    _clearTimeouts() {
        clearTimeout(this._delay);
        clearTimeout(this._timeout);
    }
    getCurrentValue() {
        return this._state;
    }
    subscribe(callback) {
        this._callbacks.add(callback);
        return ()=>{
            this._callbacks.delete(callback);
        };
    }
    constructor(loadFn, opts){
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
}
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    let promises = [];
    while(initializers.length){
        let init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(()=>{
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = ()=>{
    return new Promise((resolveInitializers, reject)=>{
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    let ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise((resolvePreload)=>{
        const res = ()=>{
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 29733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_DynamicPageBuilder; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./src/dynamicPageBuilder/utils.ts

const getNormalizedBlockName = (name)=>{
    const blockName = (0,lodash.last)(name.split("."));
    return (0,lodash.upperFirst)((0,lodash.camelCase)(blockName));
};

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/dynamicPageBuilder/BlocksList.ts

const blocksList = {
    Modes: dynamic_default()(()=>__webpack_require__.e(/* import() */ 3133).then(__webpack_require__.bind(__webpack_require__, 43133)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(43133)
                ]
        }
    }),
    InNumbersBarBlock: dynamic_default()(()=>__webpack_require__.e(/* import() */ 7619).then(__webpack_require__.bind(__webpack_require__, 47619)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(47619)
                ]
        }
    }),
    HtmlBlock: dynamic_default()(()=>__webpack_require__.e(/* import() */ 1361).then(__webpack_require__.bind(__webpack_require__, 61361)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(61361)
                ]
        }
    }),
    ProductSliderBlock: dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(6529), __webpack_require__.e(5381)]).then(__webpack_require__.bind(__webpack_require__, 55381)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(55381)
                ]
        }
    }),
    SliderBlock: dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(615), __webpack_require__.e(6872)]).then(__webpack_require__.bind(__webpack_require__, 56872)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(56872)
                ]
        }
    }),
    TextTiles2Columns: dynamic_default()(()=>__webpack_require__.e(/* import() */ 662).then(__webpack_require__.bind(__webpack_require__, 662)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(662)
                ]
        }
    }),
    ProductFilteredListBlock: dynamic_default()(()=>__webpack_require__.e(/* import() */ 7419).then(__webpack_require__.bind(__webpack_require__, 27419)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(27419)
                ]
        }
    }),
    TilesWithIconsBlock: dynamic_default()(()=>__webpack_require__.e(/* import() */ 3772).then(__webpack_require__.bind(__webpack_require__, 73772)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(73772)
                ]
        }
    }),
    TwoColumnsBlock: dynamic_default()(()=>__webpack_require__.e(/* import() */ 5485).then(__webpack_require__.bind(__webpack_require__, 15485)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(15485)
                ]
        }
    }),
    Advantages: dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(615), __webpack_require__.e(7179)]).then(__webpack_require__.bind(__webpack_require__, 97179)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(97179)
                ]
        }
    }),
    ExpandableTextRows: dynamic_default()(()=>__webpack_require__.e(/* import() */ 9016).then(__webpack_require__.bind(__webpack_require__, 39016)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(39016)
                ]
        }
    }),
    CollectingLeads: dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(9950), __webpack_require__.e(3235), __webpack_require__.e(8471)]).then(__webpack_require__.bind(__webpack_require__, 38471)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(38471)
                ]
        }
    }),
    ListWithBullets2Columns: dynamic_default()(()=>__webpack_require__.e(/* import() */ 6139).then(__webpack_require__.bind(__webpack_require__, 56139)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(56139)
                ]
        }
    }),
    PayuBlock: dynamic_default()(()=>__webpack_require__.e(/* import() */ 5585).then(__webpack_require__.bind(__webpack_require__, 55585)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(55585)
                ]
        }
    }),
    LinkNteo: dynamic_default()(()=>__webpack_require__.e(/* import() */ 881).then(__webpack_require__.bind(__webpack_require__, 20881)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(20881)
                ]
        }
    }),
    Timeline: dynamic_default()(()=>__webpack_require__.e(/* import() */ 1349).then(__webpack_require__.bind(__webpack_require__, 21349)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(21349)
                ]
        }
    }),
    SliderHtmlBlock: dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(6529), __webpack_require__.e(9703)]).then(__webpack_require__.bind(__webpack_require__, 59703)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(59703)
                ]
        }
    }),
    Button: dynamic_default()(()=>__webpack_require__.e(/* import() */ 5543).then(__webpack_require__.bind(__webpack_require__, 35543)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(35543)
                ]
        }
    }),
    Pricing: dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(8059), __webpack_require__.e(3492), __webpack_require__.e(7038)]).then(__webpack_require__.bind(__webpack_require__, 87038)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(87038)
                ]
        }
    }),
    FaqBlock: dynamic_default()(()=>__webpack_require__.e(/* import() */ 7759).then(__webpack_require__.bind(__webpack_require__, 77759)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(77759)
                ]
        }
    }),
    MovieBlock: dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(7618), __webpack_require__.e(1054)]).then(__webpack_require__.bind(__webpack_require__, 71054)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(71054)
                ]
        }
    }),
    SliderWithTabsBlock: dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(615), __webpack_require__.e(8059), __webpack_require__.e(6286), __webpack_require__.e(5809)]).then(__webpack_require__.bind(__webpack_require__, 2117)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(2117)
                ]
        }
    }),
    ScheduleBlock: dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(4313), __webpack_require__.e(1031)]).then(__webpack_require__.bind(__webpack_require__, 1031)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(1031)
                ]
        }
    }),
    Articles: dynamic_default()(()=>__webpack_require__.e(/* import() */ 7610).then(__webpack_require__.bind(__webpack_require__, 7610)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(7610)
                ]
        }
    }),
    ArticlesGroup: dynamic_default()(()=>__webpack_require__.e(/* import() */ 3920).then(__webpack_require__.bind(__webpack_require__, 83920)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(83920)
                ]
        }
    }),
    Image: dynamic_default()(()=>__webpack_require__.e(/* import() */ 1892).then(__webpack_require__.bind(__webpack_require__, 91892)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(91892)
                ]
        }
    }),
    Installments: dynamic_default()(()=>__webpack_require__.e(/* import() */ 4089).then(__webpack_require__.bind(__webpack_require__, 84089)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(84089)
                ]
        }
    }),
    ContentInTheTile: dynamic_default()(()=>__webpack_require__.e(/* import() */ 5064).then(__webpack_require__.bind(__webpack_require__, 15064)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(15064)
                ]
        }
    }),
    CodeText: dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(6937), __webpack_require__.e(4994)]).then(__webpack_require__.bind(__webpack_require__, 84994)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(84994)
                ]
        }
    }),
    InNumbers: dynamic_default()(()=>__webpack_require__.e(/* import() */ 7949).then(__webpack_require__.bind(__webpack_require__, 57949)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(57949)
                ]
        }
    }),
    Expectations: dynamic_default()(()=>__webpack_require__.e(/* import() */ 7716).then(__webpack_require__.bind(__webpack_require__, 57716)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(57716)
                ]
        }
    }),
    TestimonialBlock: dynamic_default()(()=>__webpack_require__.e(/* import() */ 2020).then(__webpack_require__.bind(__webpack_require__, 52020)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(52020)
                ]
        }
    }),
    Numbered4Columns: dynamic_default()(()=>__webpack_require__.e(/* import() */ 6817).then(__webpack_require__.bind(__webpack_require__, 66817)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(66817)
                ]
        }
    }),
    Link: dynamic_default()(()=>__webpack_require__.e(/* import() */ 7810).then(__webpack_require__.bind(__webpack_require__, 47810)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(47810)
                ]
        }
    }),
    TextBlockTzop: dynamic_default()(()=>__webpack_require__.e(/* import() */ 9877).then(__webpack_require__.bind(__webpack_require__, 39877)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(39877)
                ]
        }
    }),
    TileListOf2Columns: dynamic_default()(()=>__webpack_require__.e(/* import() */ 4976).then(__webpack_require__.bind(__webpack_require__, 74976)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(74976)
                ]
        }
    }),
    ExpandableTileCases: dynamic_default()(()=>__webpack_require__.e(/* import() */ 2372).then(__webpack_require__.bind(__webpack_require__, 22372)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(22372)
                ]
        }
    }),
    ExternalScript: dynamic_default()(()=>__webpack_require__.e(/* import() */ 7511).then(__webpack_require__.bind(__webpack_require__, 87511)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(87511)
                ]
        }
    }),
    MentorsLecturers: dynamic_default()(()=>__webpack_require__.e(/* import() */ 6532).then(__webpack_require__.bind(__webpack_require__, 26532)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(26532)
                ]
        }
    }),
    StudentStories: dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(6529), __webpack_require__.e(4630)]).then(__webpack_require__.bind(__webpack_require__, 84630)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(84630)
                ]
        }
    }),
    RecruitmentCompanies: dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(615), __webpack_require__.e(9153)]).then(__webpack_require__.bind(__webpack_require__, 39153)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(39153)
                ]
        }
    }),
    GraduateProject: dynamic_default()(()=>__webpack_require__.e(/* import() */ 7445).then(__webpack_require__.bind(__webpack_require__, 77445)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(77445)
                ]
        }
    }),
    ContactCoursesBlock: dynamic_default()(()=>__webpack_require__.e(/* import() */ 6655).then(__webpack_require__.bind(__webpack_require__, 76655)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(76655)
                ]
        }
    }),
    ContactPatronsBlock: dynamic_default()(()=>__webpack_require__.e(/* import() */ 6412).then(__webpack_require__.bind(__webpack_require__, 86412)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(86412)
                ]
        }
    }),
    Movie2Block: dynamic_default()(()=>__webpack_require__.e(/* import() */ 8797).then(__webpack_require__.bind(__webpack_require__, 48797)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(48797)
                ]
        }
    }),
    GotoShopBlock: dynamic_default()(()=>__webpack_require__.e(/* import() */ 5428).then(__webpack_require__.bind(__webpack_require__, 95428)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(95428)
                ]
        }
    }),
    ContactBlock: dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(9950), __webpack_require__.e(4867)]).then(__webpack_require__.bind(__webpack_require__, 14867)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(14867)
                ]
        }
    }),
    ArticleListingBlock: dynamic_default()(()=>__webpack_require__.e(/* import() */ 8114).then(__webpack_require__.bind(__webpack_require__, 78114)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(78114)
                ]
        }
    }),
    CoursesFilteredList: dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(9950), __webpack_require__.e(3779)]).then(__webpack_require__.bind(__webpack_require__, 53779)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(53779)
                ]
        }
    }),
    RelatedPostsBlock: dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(6529), __webpack_require__.e(8441)]).then(__webpack_require__.bind(__webpack_require__, 38441)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(38441)
                ]
        }
    }),
    ContactDepartmentsBlock: dynamic_default()(()=>__webpack_require__.e(/* import() */ 5008).then(__webpack_require__.bind(__webpack_require__, 45008)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(45008)
                ]
        }
    }),
    GroupedTimelineBlock: dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(4313), __webpack_require__.e(6517)]).then(__webpack_require__.bind(__webpack_require__, 96517)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(96517)
                ]
        }
    }),
    StructuredProductDataBlock: dynamic_default()(()=>__webpack_require__.e(/* import() */ 5539).then(__webpack_require__.bind(__webpack_require__, 65539)), {
        loadableGenerated: {
            webpack: ()=>[
                    /*require.resolve*/(65539)
                ]
        }
    })
};

;// CONCATENATED MODULE: ./src/dynamicPageBuilder/RenderBlock.tsx





const LINK_PRODUCT = "sonata.block.service.link_product";
const RenderBlock = (param)=>{
    let { blockData  } = param;
    if (blockData.type === LINK_PRODUCT) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    const blockName = getNormalizedBlockName(blockData.type);
    const Component = (0,lodash.get)(blocksList, blockName);
    if (!Component) {
        console.info("".concat(blockName, " block not found. Check the file BlocksList.ts"));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: Component ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
            blockData: blockData
        }) : ""
    });
};
/* harmony default export */ var dynamicPageBuilder_RenderBlock = (RenderBlock);

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/Arrows/Arrows.tsx


const rightArrow = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    viewBox: "0 0 512 512",
    style: {
        minHeight: "25px",
        maxHeight: "25px",
        minWidth: "25px",
        maxWidth: "25px",
        fill: "#959595",
        cursor: "pointer"
    },
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
        points: "160,115.4 180.7,96 352,256 180.7,416 160,396.7 310.5,256 "
    })
});
const leftArrow = /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    viewBox: "0 0 512 512",
    style: {
        minHeight: "25px",
        maxHeight: "25px",
        minWidth: "25px",
        maxWidth: "25px",
        fill: "#959595",
        cursor: "pointer"
    },
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
        points: "352,115.4 331.3,96 160,256 331.3,416 352,396.7 201.5,256 "
    })
});

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-media/esm/react-media.js
var react_media = __webpack_require__(87784);
;// CONCATENATED MODULE: ./src/components/PageNav/PageNav.tsx






const PageNav = (param)=>{
    let { links , className  } = param;
    const { asPath: currentUrl  } = (0,router.useRouter)();
    const ref = (0,react.useRef)(null);
    const SCROLL_STEP = 200;
    const handleLeftClick = ()=>{
        if (ref && ref.current) {
            var _ref_current;
            const currentScrollLeft = (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.scrollLeft;
            ref.current.scrollLeft = currentScrollLeft - SCROLL_STEP;
        }
    };
    const handleRightClick = ()=>{
        if (ref && ref.current) {
            var _ref_current;
            const currentScrollLeft = (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.scrollLeft;
            ref.current.scrollLeft = currentScrollLeft + SCROLL_STEP;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "scrolling-menu",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_media/* default */.Z, {
                query: "(max-width: 765px)",
                defaultMatches: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    onClick: handleLeftClick,
                    className: "arrow arrow__left",
                    children: leftArrow
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pageNav ".concat(className),
                ref: ref,
                children: links.map((link, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        passHref: true,
                        href: link.url,
                        className: "pageNav__link ".concat(currentUrl == link.url ? "pageNav__link--active" : ""),
                        children: link.name
                    }, index))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_media/* default */.Z, {
                query: "(max-width: 765px)",
                defaultMatches: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    onClick: handleRightClick,
                    className: "arrow arrow__right",
                    children: rightArrow
                })
            })
        ]
    });
};
/* harmony default export */ var PageNav_PageNav = (PageNav);

;// CONCATENATED MODULE: ./src/components/PageNav/index.ts


;// CONCATENATED MODULE: ./src/dynamicPageBuilder/PageWithTabs.tsx





const PageWithTabs = (param)=>{
    let { pages  } = param;
    const { asPath: currentUrl , replace  } = (0,router.useRouter)();
    const pageToRender = pages.find((p)=>p.page.url === currentUrl);
    const blocksList = [];
    if (pageToRender && pageToRender.blocks) {
        pageToRender.blocks.forEach((block, index)=>{
            if (block.type) blocksList.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(dynamicPageBuilder_RenderBlock, {
                blockData: block
            }, "".concat(index, "_").concat(block.type)));
        });
    }
    const links = pages.map((p)=>({
            name: p.page.name,
            url: p.page.url
        }));
    (0,react.useEffect)(()=>{
        if (!pageToRender && pages.length > 0) {
            const [pageData] = pages;
            replace(pageData.page.url);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageNav_PageNav, {
                links: links,
                className: "pageTabNavigation"
            }),
            blocksList
        ]
    });
};
/* harmony default export */ var dynamicPageBuilder_PageWithTabs = (PageWithTabs);

;// CONCATENATED MODULE: ./utils/StructuredDataProvider.tsx


class StructuredDataProvider {
    addDataToStructuredData(block) {
        switch(block.type){
            case "sonata.block.service.faq_block":
                {
                    const questionsItems = [];
                    const questions = (0,lodash.get)(block, "questions");
                    questions.faq.forEach((item)=>{
                        questionsItems.push({
                            "@type": "Question",
                            name: item.questions,
                            acceptedAnswer: {
                                "@type": "Answer",
                                text: item.answers
                            }
                        });
                    });
                    const faqDataIndex = this._scripts.findIndex((script)=>script["@type"] === "FAQPage");
                    if (faqDataIndex === -1) {
                        this._scripts.push({
                            "@context": "https://schema.org",
                            "@type": "FAQPage",
                            mainEntity: questionsItems
                        });
                    } else {
                        const currentFaqData = this._scripts[faqDataIndex];
                        this._scripts[faqDataIndex] = {
                            ...currentFaqData,
                            mainEntity: [
                                ...currentFaqData.mainEntity,
                                ...questionsItems
                            ]
                        };
                    }
                    break;
                }
        }
    }
    getScriptsForRender() {
        return this._scripts.map((script, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(script)
                }
            }, "structured-jsonld-".concat(index)));
    }
    constructor(){
        this._scripts = [];
    }
}

;// CONCATENATED MODULE: ./src/components/DynamicPageBuilder.tsx





const DynamicPageBuilder = (param)=>{
    let { blocks  } = param;
    const blocksList = [];
    const [, pages] = blocks;
    const isPageWithTabs = Array.isArray(pages);
    const structuredDataProvider = new StructuredDataProvider();
    if (isPageWithTabs) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(dynamicPageBuilder_PageWithTabs, {
            pages: pages
        });
    }
    blocks.forEach((block, index)=>{
        if (block.type) {
            structuredDataProvider.addDataToStructuredData(block);
            blocksList.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(dynamicPageBuilder_RenderBlock, {
                blockData: block
            }, "".concat(index, "_").concat(block.type)));
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            structuredDataProvider.getScriptsForRender(),
            blocksList
        ]
    });
};
/* harmony default export */ var components_DynamicPageBuilder = (DynamicPageBuilder);


/***/ }),

/***/ 83331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _blocks_MainHeader_utils_LogoProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49611);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);





const SEO = (param)=>{
    let { description , title , picture , canonicalUrl , noIndex  } = param;
    const { locale  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const ogImageSrc = picture && picture.publicUrl ? "".concat("https://www-api.coderslab.si/").concat(picture.publicUrl) : (0,_blocks_MainHeader_utils_LogoProvider__WEBPACK_IMPORTED_MODULE_3__/* .getLogoSrcForCurrentLang */ .j)(locale);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width,initial-scale=1,shrink-to-fit=no"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: ogImageSrc
            }),
            noIndex && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex"
            }),
            canonicalUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SEO);


/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(37645)


/***/ })

}]);